import { useMemo } from 'react';
import { PLAYBACK_HISTORY_MINUTES } from 'src/@realtime/constants';
import { useConfigSelectors } from 'src/app/reducers';

export const useIsHistoricalOnly = () => {
  const configSelectors = useConfigSelectors();
  const {
    realtime: { isHistoricalOnly, historicalOnlyMinsBefore },
  } = configSelectors.getConfig();

  const historicalMinsBuffer = historicalOnlyMinsBefore + PLAYBACK_HISTORY_MINUTES;

  return useMemo(() => ({ isHistoricalOnly, historicalMinsBuffer }), [
    isHistoricalOnly,
    historicalOnlyMinsBefore,
  ]);
};
